import React from 'react';
import Sidebar from './Sidebar';

const MainLayout = ({ children }) => {
  return (
    <div className="layout-wrapper">
      <Sidebar />
      <div className="main-wrapper">
        <main className="content-container">
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
